module.exports = "<div class=\"media-dropzone dropzone\"></div>";


//////////////////
// WEBPACK FOOTER
// ./src/cmsCore/MediaModules/MediaDropzone/media-dropzone.html
// module id = 955
// module chunks = 0